import apiClient from "@/helpers/api.service";

export default {
    list(params = {}) {
        return apiClient.get("/order/list", { params });
    },
    getBulkDetails(orderNumber) {
        return apiClient.get(`/order/${orderNumber}/bulk-details`);
    },
    getBulkChargeDetails(orderNumber) {
        return apiClient.get(`/order/${orderNumber}/bulk-charge-details`);
    },
    getSSCCDetails(orderNumber) {
        return apiClient.get(`/order/${orderNumber}/sscc-details`);
    },
    closeTechOrder(orderNumber) {
        return apiClient.post(`/order/${orderNumber}/close-tech`);
    },
    clearLine(orderNumber) {
        return apiClient.post(`/order/${orderNumber}/clear-line`);
    },
    rescheduleOrder(data) {
        return apiClient.post('/order/reschedule', data);
    },
    checkMaterial(orderNumber) {
        return apiClient.get(`/order/${orderNumber}/check-material`);
    },
    createExtraSupply(data) {
        return apiClient.post('/order/extra-supply', data);
    },
    deliverySto(orderNumber) {
        return apiClient.post(`/order/${orderNumber}/delivery-sto`);
    },
    returnBulk(data) {
        return apiClient.post('/order/return-bulk', data);
    },
    releaseOrder(orderNumber, targetQuantity, skipValidation = false, productionLine = '', startDate = '', orderType = '') {
        return apiClient.post(`/order/${orderNumber}/release`, {
            target_quantity: targetQuantity,
            skip_validation: skipValidation,
            production_line: productionLine,
            start_date: startDate,
            order_type: orderType
        });
    },
    cancelSupply(orderNumber) {
        return apiClient.post(`/order/${orderNumber}/cancel-supply`);
    },
    adjustInventory(data) {
        return apiClient.post('/order/adjust-inventory', data);
    },
    setUserStatus(orderNumber) {
        return apiClient.post(`/order/${orderNumber}/set-user-status`);
    }
}